export class ProjectFilters {
    name: string;

    constructor() {}
}
